import { getArrayDuplicateValues } from '../utils/generic';

export function genGroupsValidationData({ sheetData, sheetMap }) {
  const {
    code: groupCodeIndex,
    number: groupNumberIndex,
    parentCode: groupParentCodeIndex,
  } = sheetMap;

  const groups = sheetData
    .filter((group) => {
      return groupCodeIndex < group.length
        ? group[groupCodeIndex] !== undefined
        : false;
    })
    .slice(1); // remove heder row

  const rowsCount = groups.length;

  const groupCodes = [];
  const groupNumbers = [];
  const sameCodeAndParentCode = [];

  // extract code and number for each group
  groups.forEach((group) => {
    groupCodes.push(group[groupCodeIndex]);
    group[groupNumberIndex] && groupNumbers.push(group[groupNumberIndex]);
    if (group[groupCodeIndex] === group[groupParentCodeIndex]) {
      sameCodeAndParentCode.push(group[groupCodeIndex]);
    }
  });

  const groupCodesDuplicates = getArrayDuplicateValues(groupCodes);
  const groupNumbersDuplicates = getArrayDuplicateValues(groupNumbers);

  return {
    groupCodesDuplicates,
    groupNumbersDuplicates,
    sameCodeAndParentCode,
    rowsCount,
  };
}
